/*!
** Project: Go Adventure
** Author: Piotr Kulpinski <piotr@kulpinski.pl>
** --------------------------------
* */

import ui from './utils/ui';
import panels from './utils/panels';

// UI
ui.init();

// Utils
panels.init();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/go-adventure-blog/src/scripts/app.js